import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-sub-navbar',
  templateUrl: './sub-navbar.component.html',
  styleUrls: ['./sub-navbar.component.scss']
})
export class SubNavbarComponent implements OnInit {

  stars: number[] = [1, 2, 3, 4, 5];
  selectedValue: number;
  

  ngOnInit(): void {
  }

  ShowModal() {
    $('#warningModal').modal('show');
  }

  countStar(star) {
    this.selectedValue = star;

    if (this.selectedValue > 0) {
      $('#warningModal').modal('hide');
      sessionStorage.setItem('#warningModal', 'true');

    } else if (this.selectedValue == 0) {
      // $('#warningModal').modal('show');
      sessionStorage.setItem('#warningModal', 'false')

    }
  }


}
